import React from "react";
import { NavLink } from "react-router-dom";
import useQuestion from "../hooks/useQuestion";

import QuestionBadge from "./QuestionBadge";

const QuestionRow = ({ questionID }) => {
  const { question } = useQuestion({ questionID });

  return (
    <div className="list-group-item list-group-item-action d-flex justify-content-between align-items-center">
      <NavLink
        className="stretched-link text-dark"
        to={`/${question.category}/${question.topic}/${questionID}`}
      >
        {question.number}. {question.question}
      </NavLink>
      <QuestionBadge questionID={questionID} />
    </div>
  );
};

export default QuestionRow;
